<template>
      <v-container
          fluid
      >
        <v-row>
          <v-col
            cols="4"
            xs="4"
            sm="4"
            md="3"
            lg="3"
            xl="3"
          >
            <v-select
                :items="getTags"
                v-model="selectedTagUUID"
                item-text="name"
                item-value="uuid"
                label="Tag"
                clearable
                dense
                hide-details
                outlined
            >
            </v-select>
          </v-col>
          <v-col
              cols="4"
              xs="4"
              sm="4"
              md="3"
              lg="3"
              xl="3"
          >
            <v-text-field
                v-model="searchBox"
                label="Suche"
                clearable
                dense
                hide-details
                outlined
            >
            </v-text-field>
          </v-col>
          <v-spacer></v-spacer>
          <v-col
            cols="3"
            align="right"
          >
            <v-btn
                v-if="editMode"
                class="mr-5"
                @click="newTag"
            >
              Neuer Tag
            </v-btn>
            <v-btn
                color="primary"
                icon
                @click="editMode = !editMode"
            >
              <v-icon
                v-if="editMode"
              >
                mdi-cog-off-outline
              </v-icon>
              <v-icon
                  v-else
              >
                mdi-cog-outline
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row
        >
          <v-col
              cols="3"
          >
            <tag-editor-box
                v-if="editMode"
                :currentTagUUID="selectedTagUUID"
            ></tag-editor-box>
          </v-col>
        </v-row>
        <v-row
        >
          <v-col
              v-for="(columnName, index) in getColumns"
              :key="index"
              cols="12"
              xs="12"
              sm="6"
              md="6"
              lg="3"
              xl="3"
          >
            <v-card
            >
              <v-card-title>
                {{columnName}}
                <v-spacer></v-spacer>
                <div
                  v-if="index==0"
                >
                  <v-btn
                    class="primary"
                    @click="newCard"
                  >
                    Neue Karte
                  </v-btn>
                </div>
              </v-card-title>
              <v-card-text
                  :style="'overflow: auto; max-height: ' + columnHeight + 'px; scrollbar-width: none; -ms-overflow-style: none;'"
              >
                  <v-card
                      v-for="(card, cardIndex) in getCards.filter(cardF => (currentSelectedCard == null && cardF.state == index) || (currentSelectedCard != null && currentSelectedCard.state == cardF.state))"
                      :key="cardIndex"
                      :class="(card == currentSelectedCard) ? 'primary mb-1' : 'secondary mb-1'"
                      @click="(currentSelectedCard == card) ? currentSelectedCard = null : currentSelectedCard = card"
                  >
                    <v-card-title
                    >
                      {{card.name}}
                      <div
                          v-if="getTag(card.tag) != null"
                          :style="'position: relative; top: -10px; left: 3px; color: ' + getTag(card.tag).color"
                          :class="getTag(card.tag).color"
                      >
                        <h6
                        >
                          {{ getTag(card.tag).name }}
                        </h6>
                      </div>
                    </v-card-title>
                  </v-card>
              </v-card-text>
            </v-card>
          </v-col>
            <v-col
                v-if="currentSelectedCard"
                cols="12"
                xs="12"
                sm="12"
                md="6"
                lg="9"
                xl="9"
            >
                <card-editor-box
                    :currentSelectedCard="currentSelectedCard"
                ></card-editor-box>
            </v-col>
        </v-row>
      </v-container>
</template>

<script>

import TagEditorBox from "../components/Kanban/TagEditorBox";
import CardEditorBox from "../components/Kanban/CardEditorBox";

export default {
  name: "Kanban",
  components: {CardEditorBox, TagEditorBox},
  data: () => ({
    //general
    editMode: false,
    //nav
    selectedTagUUID: null,
    searchBox: null,

    currentSelectedCard: null,
  }),
  computed: {
    getColumns(){
      let columns = this.$store.getters.getKanban.columns
      if(this.currentSelectedCard != null){
        return columns.filter(columnName => columns.indexOf(columnName) == this.currentSelectedCard.state)
      }
      return columns
    },
    getTags(){
      return this.$store.getters.getKanban.tags
    },
    getCards(){
      let cards = this.$store.getters.getKanban.cards
      if(this.selectedTagUUID != null && this.selectedTagUUID.length > 0){
        cards = cards.filter(cardF => cardF.tag == this.selectedTagUUID || this.currentSelectedCard == cardF)
      }
      if(this.searchBox != null && this.searchBox.length > 0){
        cards = cards.filter(cardF => (cardF.name.includes(this.searchBox) || this.currentSelectedCard == cardF || cardF.text.includes(this.searchBox)))
      }
      return cards
    },
    columnHeight(){
      return this.$vuetify.breakpoint.height - 96 - 180
    }
  },
  methods: {
    pad(n){
      return n<10 ? '0'+n : n
    },
    getTimeStamp(){
      let date = new Date();
      return date.getFullYear() + "-" + this.pad((date.getMonth() + 1)) + "-" + this.pad(date.getDate()) + " " +  this.pad(date.getHours()) + ":" + this.pad(date.getMinutes());
    },
    getTag(uuid) {
      if (uuid != null) {
        for (let index in this.$store.getters.getKanban.tags) {
          let tag = this.$store.getters.getKanban.tags[index]
          if (tag.uuid == uuid) {
            return tag
          }
        }
      }
      return null
    },
    getRandomUUID() {
      return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
          (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
      )
    },
    newTag(){
      let uuid = this.getRandomUUID()
      let newTag = {"uuid": uuid, "name": "Neuer Tag", "color": this.$vuetify.theme.currentTheme.primary}
      let tags = this.$store.getters.getKanban.tags
      tags.push(newTag)
      this.$store.commit('updateTags', tags)
      this.$store.dispatch('update', {"context": '/set/kanban/tags/' + uuid, "payload": newTag})
      this.selectedTagUUID = uuid
    },
    newCard(){
      let uuid = this.getRandomUUID()
      let state = (this.currentSelectedCard == null) ? 0 : this.currentSelectedCard.state
      let newCard = {"uuid": uuid, "state": state, "name": "Neue Karte", "prio": 0, "text": "", "created": this.getTimeStamp(), "lastEdited": this.getTimeStamp()}
      let cards = this.$store.getters.getKanban.cards
      cards.push(newCard)
      this.$store.commit("updateCards", cards)
      this.$store.dispatch('update', {"context": '/set/kanban/cards/' + uuid, "payload": newCard})
      this.currentSelectedCard = newCard

    },


    lowerPriority(){
      //alle indexses kleiner als eignes reduzieren
    },
    higherPriority(){
      //alle indizes
    }
  },
  mounted() {
    this.$store.dispatch('update', {"context": '/get/kanban'})
    let store = this.$store
    this.timer = window.setInterval(function(){
      store.dispatch('update', {"context": '/get/kanban'})
    }, 60000);
  },
  destroyed() {
    clearInterval(this.timer)
  }
}
</script>

<style scoped>

</style>
